"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathGet = exports.pathMerge = void 0;
function pathMerge(obj, pathStr, toMerge) {
    if (!pathStr)
        return toMerge;
    var pathArr = pathStr.split('.');
    // @ts-ignore
    var lastPath = pathArr.pop();
    var tobj = __assign({}, obj);
    var lastBranch = pathArr.reduce(function (o, p) {
        !o[p] && (o[p] = {});
        if (Array.isArray(o[p])) {
            o[p] = __spreadArrays(o[p]);
            return o[p];
        }
        o[p] = __assign({}, o[p]);
        return o[p];
    }, tobj);
    lastBranch[lastPath] = toMerge;
    return tobj;
}
exports.pathMerge = pathMerge;
function pathGet(obj, pathStr) {
    if (!pathStr)
        return obj;
    var pathArr = pathStr.split('.');
    return pathArr.reduce(function (tmp, p) {
        if (tmp === null)
            return null;
        if (typeof tmp[p] === 'undefined')
            return null;
        return tmp[p];
    }, obj);
}
exports.pathGet = pathGet;
